import { combineReducers } from "redux";
import leadersReducer from "./leaders.reducer";
import supervisorsReducer from "./supervisors.reducer";
import sellersReducer from "./sellers.reducer";
import authReducer from "./auth.reducer";
import ordersReducer from "./orders/orders.reducer";
import sellersStatsReducer from "./orders/sellerStats.reducer";
import originsReducer from "./origins.reducer";
import statesReducer from "./states.reducer";
import channelsReducer from "./channels.reducer";
import clientsReducer from "./clients.reducer";
import operationTypesReducer from "./operationTypes.reducer";

export default combineReducers({
  leaders: leadersReducer,
  supervisors: supervisorsReducer,
  sellers: sellersReducer,
  orders: ordersReducer,
  sellersStats: sellersStatsReducer,
  auth: authReducer,
  origins: originsReducer,
  states: statesReducer,
  channels: channelsReducer,
  clients: clientsReducer,
  operationTypes: operationTypesReducer
});
